import React, {useState, useRef, useEffect} from "react";
import {
    Form,
    Table,
    notification,
    Tooltip,
    Popconfirm,
} from "../../components/Elements/appUtils";
import PageHeader from "../../components/Elements/pageHeader";
import axios from "axios";
import {GetEachFormFields} from "../../components/_utils/formUtils";
import {apiUrl} from "../../setting";
import {getToken} from "../../request";
import EditMainCategory from "./editMainCategory"
// import Modal from "../../components/Elements/Modal";
import Drawer from "../../components/Elements/Drawer";
import ReactDragListView from "react-drag-listview";


import {
    addMainCategoryUrl,
    getMainCategoryUrl,
    deleteMainCategoryUrl,
    updateMainCategoryUrl,
} from "./api";

import {getMainMenuUrl} from "../mainmenu/api";

function MainCategory(props) {
    const tableRef = useRef();

    /* ===============================
       STATES
    =============================== */
    const [mainMenus, setMainMenus] = useState([]);
    const [selectedMainMenu, setSelectedMainMenu] = useState("");
    const [mainCategoryFile, setMainCategoryFile] = useState("");
    const [mainCategoryBanner, setMainCategoryBanner] = useState("");
    const [fileReset, setFileReset] = useState(0);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [editData, setEditData] = useState(null);
    const [showIndexModal, setShowIndexModal] = useState(false);
    const [updatedIndexes, setUpdatedIndexes] = useState({});
    const [indexSaveLoading, setIndexSaveLoading] = useState(false);
    const [indexModalData, setIndexModalData] = useState([]);

    /* ===============================
       LOAD MAIN MENUS (Dropdown)
    =============================== */
    useEffect(() => {
        if (selectedMainMenu) {
            tableRef.current?.reload();
        }
    }, [selectedMainMenu]);
    useEffect(() => {
        loadMainMenus();
    }, []);

    // const loadMainMenus = async () => {
    //   try {
    //     const { data } = await axios.get(getMainMenuUrl(), getToken());
    //
    //     if (data?.data) {
    //       setMainMenus(data.data);
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // };
    const loadMainMenus = async () => {
        try {
            const {data} = await axios.get(getMainMenuUrl(), getToken());

            if (data?.data) {
                const menuList = data.data || [];
                setMainMenus(menuList);

                const defaultMenu =
                    menuList.find((item) => item.isDefault === true) || menuList[0];

                // if (defaultMenu) {
                //   setSelectedMainMenu(defaultMenu._id);
                //
                //   props.form.setFieldsValue({
                //     mainMenuId: defaultMenu._id,
                //   });
                // }
                if (defaultMenu) {
                    setSelectedMainMenu(defaultMenu._id);

                    setTimeout(() => {
                        props.form.setFieldsValue({
                            mainMenuId: defaultMenu._id,
                        });
                    }, 0);
                }
            }
        } catch (error) {
            console.log(error);
        }
    };
    const handleFileChange = (e) => {
        const file = e.files[0];
        setMainCategoryFile(file);
    };
    const handleBannerChange = (e) => {
        const file = e.files[0];
        setMainCategoryBanner(file);
    };

    /* ===============================
       ADD + UPDATE
    =============================== */
    //   const handleSubmit = (e) => {
    //     e.preventDefault();

    //     props.form.validateFields(async (err, valData) => {
    //       if (err) return;

    //       try {

    //         let response;

    //         if (isEdit) {
    //           response = await axios.put(
    //             updateMainCategoryUrl(editId),
    //             valData,
    //             getToken()
    //           );
    //         } else {
    //           response = await axios.post(
    //             addMainCategoryUrl(),
    //             valData,
    //             getToken()
    //           );
    //         }

    //         if (response.data.success) {

    //           notification.success({
    //             message: response.data.message || "Success",
    //           });

    //           props.form.resetFields();
    //           setIsEdit(false);
    //           setEditId(null);

    //          tableRef.current.reload();

    // setTimeout(() => {
    //   tableRef.current.reload();
    // }, 200);
    //         }

    //       } catch (error) {
    //         console.log(error);
    //       }
    //     });
    //   };
    // const resetFormState = () => {
    //   props.form.resetFields();
    //   setIsEdit(false);
    //   setEditId(null);
    //   setMainCategoryFile("");
    // };
    const resetFormState = () => {
        props.form.resetFields();

        props.form.setFieldsValue({
            mainCategoryName: "",
            mainCategoryDescription: "",
            mainMenuId: selectedMainMenu || undefined,
        });

        setMainCategoryFile("");
        setMainCategoryBanner("");
        setFileReset((prev) => prev + 1);
    };
    const handleSubmit = (e) => {
        e.preventDefault();

        props.form.validateFields(async (err, valData) => {
            if (err) return;

            try {
                const fd = new FormData();
                fd.append("obj", JSON.stringify(valData));

                if (mainCategoryFile && mainCategoryFile.name) {
                    fd.append("mainCategoryFile", mainCategoryFile);
                }

                if (mainCategoryBanner && mainCategoryBanner.name) {
                    fd.append("mainCategoryBanner", mainCategoryBanner);
                }

                const response = await axios.post(
                    addMainCategoryUrl(),
                    fd,
                    getToken()
                );

                if (response.data.success) {
                    notification.success({
                        message: response.data.message || "Success",
                    });

                    resetFormState();
                    tableRef.current.reload();
                } else {
                    notification.error({
                        message: response.data.message || "Something went wrong",
                    });
                }
            } catch (error) {
                console.log("SUBMIT ERROR =>", error);
                console.log("BACKEND RESPONSE =>", error?.response?.data);

                notification.error({
                    message: error?.response?.data?.message || "Request failed",
                });
            }
        });
    };

    /* ===============================
       TABLE API
    =============================== */
    const apiRequest = async (params) => {
        try {
            // 🚨 If no Main Menu selected → show empty table
            if (!selectedMainMenu) {
                return {
                    data: [],
                    success: true,
                    total: 0,
                };
            }

            // If selected → filter categories
            params.mainMenuId = selectedMainMenu;

            const {data} = await axios.get(getMainCategoryUrl(), {
                ...getToken(),
                params,
            });

            return data;
        } catch (error) {
            console.log(error);
            return {
                data: [],
                success: false,
                total: 0,
            };
        }
    };
    const loadAllMainCategoriesForIndexModal = async () => {
        try {
            if (!selectedMainMenu) {
                notification.warning({
                    message: "Please select Main Menu first",
                });
                return;
            }

            const {data} = await axios.get(getMainCategoryUrl(), {
                ...getToken(),
                params: {
                    mainMenuId: selectedMainMenu,
                    sortField: "index",
                    sortOrder: "asc",
                    results: 1000,
                    page: 1,
                },
            });

            const fullList =
                data?.data || data?.results || data?.docs || data?.rows || [];

            const preparedData = fullList.map((item, idx) => ({
                ...item,
                index: item.index || idx + 1,
                originalIndex: item.index || idx + 1,
            }));

            setIndexModalData(preparedData);
            setUpdatedIndexes({});
            setShowIndexModal(true);
        } catch (error) {
            console.log("LOAD INDEX MODAL ERROR:", error);
            notification.error({
                message: "Failed to load main category order list",
            });
        }
    };

    const openIndexModal = async () => {
        await loadAllMainCategoriesForIndexModal();
    };

    const closeIndexModal = () => {
        setShowIndexModal(false);
        setUpdatedIndexes({});
    };

    const handleSaveIndexes = async () => {
        try {
            setIndexSaveLoading(true);

            const categoryList = indexModalData || [];

            const finalIndexes = categoryList.map((item) => ({
                _id: item._id,
                index:
                    updatedIndexes[item._id] !== undefined
                        ? Number(updatedIndexes[item._id])
                        : Number(item.index || 0),
            }));

            const indexValues = finalIndexes.map((item) => item.index);
            const hasDuplicateIndex = indexValues.some(
                (val, i) => indexValues.indexOf(val) !== i
            );

            if (hasDuplicateIndex) {
                notification.error({
                    message: "Each main category must have a unique index",
                });
                setIndexSaveLoading(false);
                return;
            }

            // const promises = categoryList.map((item) => {
            //   const newIndex =
            //       updatedIndexes[item._id] !== undefined
            //           ? Number(updatedIndexes[item._id])
            //           : Number(item.index || 0);
            //
            //   if (newIndex !== Number(item.originalIndex || 0)) {
            //     const fd = new FormData();
            //     fd.append(
            //         "obj",
            //         JSON.stringify({
            //           _id: item._id,
            //           index: newIndex,
            //         })
            //     );
            //
            //     return axios.post(updateMainCategoryUrl(), fd, getToken());
            //   }
            //
            //   return null;
            // });
            const promises = categoryList.map((item) => {
                const newIndex =
                    updatedIndexes[item._id] !== undefined
                        ? Number(updatedIndexes[item._id])
                        : Number(item.index || 0);

                if (newIndex !== Number(item.originalIndex || 0)) {
                    const fd = new FormData();
                    fd.append(
                        "obj",
                        JSON.stringify({
                            _id: item._id,
                            index: newIndex,
                        })
                    );

                    return axios.put(updateMainCategoryUrl(item._id), fd, getToken());
                }

                return null;
            });

            await Promise.all(promises.filter(Boolean));

            notification.success({
                message: "Indexes updated successfully",
            });

            closeIndexModal();
            tableRef.current.reload();
        } catch (error) {
            console.log("INDEX UPDATE ERROR:", error);
            notification.error({
                message: error?.response?.data?.message || "Failed to update indexes",
            });
        } finally {
            setIndexSaveLoading(false);
        }
    };

    /* ===============================
       DELETE
    =============================== */
    const deleteData = async (id) => {
        try {
            const resp = await axios.delete(deleteMainCategoryUrl(id), getToken());

            if (resp?.data?.success) {
                notification.success({
                    message: resp.data.message || "Deleted successfully",
                });
                tableRef.current.reload();
            } else {
                notification.error({
                    message: resp?.data?.message || "Delete failed",
                });
            }
        } catch (error) {
            notification.error({
                message: error?.response?.data?.message || "Delete failed",
            });
        }
    };

    /* ===============================
       EDIT
    =============================== */
    // const handleEdit = (item) => {
    //   setEditId(item._id);
    //   setIsEdit(true);

    //   props.form.setFieldsValue({
    //     mainCategoryName: item.mainCategoryName,
    //     mainMenuId: item?.mainMenuId?._id,
    //   });
    // };
    const handleEdit = (item) => {
        if (item.source === "legacy") {
            notification.warning({
                message: "Legacy row cannot be edited. Use the form above and click Submit.",
            });
            return;
        }

        setEditData(item);
        setDrawerOpen(true);
    };
    const closeDrawer = () => {
        setDrawerOpen(false);
        setEditData(null);
    };
    const handleDragEnd = (fromIndex, toIndex) => {
        const data = [...indexModalData];
        const item = data.splice(fromIndex, 1)[0];
        data.splice(toIndex, 0, item);

        const updatedData = data.map((item, index) => ({
            ...item,
            index: index + 1,
            originalIndex: item.originalIndex,
        }));

        setIndexModalData(updatedData);

        const updatedIndexMap = {};
        updatedData.forEach((item) => {
            updatedIndexMap[item._id] = item.index;
        });

        setUpdatedIndexes(updatedIndexMap);
    };

    const dragProps = {
        onDragEnd: handleDragEnd,
        nodeSelector: "tr",
        handleSelector: ".drag-handle",
    };

    /* ===============================
       TABLE COLUMNS
    =============================== */
    const columns = [
        {
            title: "Main Menu",
            render: (_, item) => item?.mainMenuId?.mainMenuName || "-",
        },
        {
            title: "Main Category",
            dataIndex: "mainCategoryName",
        },
        {
            title: "Index",
            dataIndex: "index",
            key: "index",
            render: (text) => text ?? 0,
        },
        {
            title: "Image",
            render: (_, item) => {
                return item?.mainCategoryFile?.path ? (
                    <a
                        href={`${apiUrl}${item.mainCategoryFile.path}`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-sm btn-link"
                    >
                        View Image
                    </a>
                ) : (
                    "-"
                );
            },
        },
        {
            title: "Banner",
            render: (_, item) => {
                return item?.mainCategoryBanner?.path ? (
                    <a
                        href={`${apiUrl}${item.mainCategoryBanner.path}`}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-sm btn-link"
                    >
                        View Banner
                    </a>
                ) : (
                    "-"
                );
            },
        },
        {
            title: "Action",
            render: (_, item) => (
                <>
                    {/* EDIT */}
                    {/* <Tooltip title="Edit">
            <i
              className="fa fa-edit"
              style={{ cursor: "pointer" }}
              onClick={() => handleEdit(item)}
            />
          </Tooltip> */}
                    <Tooltip title={item.source === "legacy" ? "Create this from form above" : "Edit"}>
                        <i
                            className="fa fa-edit"
                            style={{
                                cursor: item.source === "legacy" ? "not-allowed" : "pointer",
                                opacity: item.source === "legacy" ? 0.4 : 1,
                            }}
                            onClick={() => {
                                if (item.source === "legacy") {
                                    notification.warning({
                                        message: "Legacy row cannot be edited. Use the form above and click Submit.",
                                    });
                                    return;
                                }
                                handleEdit(item);
                            }}
                        />
                    </Tooltip>

                    {/* DELETE */}
                    <Tooltip title="Delete">
                        <Popconfirm
                            title="Delete Main Category?"
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => deleteData(item._id)}
                        >
                            <i
                                className="fa fa-trash"
                                style={{marginLeft: 20, cursor: "pointer"}}
                            />
                        </Popconfirm>
                    </Tooltip>
                </>
            ),
        },
    ];

    /* ===============================
       FORM FIELDS
    =============================== */
    const inputTypes = {
        fields: [
            {
                key: "mainMenuId",
                label: "Main Menu",
                span: "col-md-4",
                type: "select",
                options: mainMenus,
                keyAccessor: (x) => x._id,
                valueAccessor: (x) => x.mainMenuName,

                // onChange: (value) => {
                //   setSelectedMainMenu(value);
                //
                //   setTimeout(() => {
                //     tableRef.current.reload();
                //   }, 150);
                // },
                onChange: (value) => {
                    setSelectedMainMenu(value);
                    props.form.setFieldsValue({
                        mainMenuId: value,
                    });
                },
            },

            {
                key: "mainCategoryName",
                label: "Main Category Name",
                span: "col-md-4",
                type: "text",
            },

            {
                key: "mainCategoryFile",
                label: "Main Category File",
                span: "col-md-4",
                type: "file",
                fileName: mainCategoryFile,
                onChange: ({target}) => {
                    handleFileChange(target);
                },
            },
            {
                key: "mainCategoryDescription",
                label: "Description",
                span: "col-md-4",
                type: "textarea"
            },
            {
                key: "mainCategoryBanner",
                label: "Main Category Banner",
                span: "col-md-4",
                type: "file",
                fileName: mainCategoryBanner,
                onChange: ({target}) => {
                    handleBannerChange(target);
                },
            },
        ],
    };

    /* ===============================
       UI
    =============================== */
    return (
        <PageHeader title={"Main Category"}>
            {/* FORM */}
            <Form onSubmit={handleSubmit}>
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            {/*{inputTypes.fields.map((item, key) => (*/}
                            {/*  <div className={item.span} key={key}>*/}
                            {/*    <GetEachFormFields {...props.form} item={item} />*/}
                            {/*  </div>*/}
                            {/*))},*/}
                            {inputTypes.fields.map((item, index) => {
                                let renderKey = item.key || index;

                                if (item.key === "mainCategoryFile") {
                                    renderKey = `mainCategoryFile-${fileReset}`;
                                }

                                if (item.key === "mainCategoryBanner") {
                                    renderKey = `mainCategoryBanner-${fileReset}`;
                                }

                                return (
                                    <div className={item.span} key={renderKey}>
                                        <GetEachFormFields {...props.form} item={item}/>
                                    </div>
                                );
                            })}
                        </div>

                        <button className="btn btn-success">
                            SUBMIT
                        </button>

                    </div>
                </div>
            </Form>
            <div className="mt-3 mb-2">
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={openIndexModal}
                >
                    Update Index
                </button>
            </div>
            {/* TABLE */}
            <div className="card mt-3">
                <div className="card-body">
                    <Table ref={tableRef} apiRequest={apiRequest} columns={columns}/>
                </div>
            </div>
            <Drawer
                title="Update Main Category Order"
                placement="right"
                onClose={closeIndexModal}
                visible={showIndexModal}
                width={'35%'}
                destroyOnClose={false}
                footer={(
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                            marginTop: "20px",
                        }}
                    >
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={closeIndexModal}
                        >
                            Cancel
                        </button>

                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSaveIndexes}
                            disabled={indexSaveLoading}
                        >
                            {indexSaveLoading ? "Saving..." : "Save"}
                        </button>
                    </div>
                )}
            >
                <div className="container-fluid">
                    <ReactDragListView {...dragProps}>
                        <table className="table table-bordered">
                            <thead>
                            <tr>
                                <th style={{width: "60px"}}>Move</th>
                                <th>Main Category</th>
                                <th style={{width: "120px"}}>Index</th>
                            </tr>
                            </thead>
                            <tbody>
                            {indexModalData.map((item) => (
                                <tr key={item._id}>
                                    <td
                                        className="drag-handle"
                                        style={{cursor: "move", textAlign: "center"}}
                                    >
                                        <i className="fa fa-bars"/>
                                    </td>
                                    <td>{item.mainCategoryName}</td>
                                    <td>{updatedIndexes[item._id] ?? item.index ?? 0}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </ReactDragListView>


                </div>
            </Drawer>
            <EditMainCategory
                visible={drawerOpen}
                editData={editData}
                mainMenus={mainMenus}
                onClose={closeDrawer}
                reloadTable={() => {
                    tableRef.current.reload();
                }}
            />
        </PageHeader>
    );
}

export default Form.create()(MainCategory);
